import { Injectable } from "@angular/core";
import { BaseService } from "../../shared/services/base.service";
import { AppComponent } from "../../app.component";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { SupportFaq } from "../models/supportFaqs.interface";
import { Router } from "@angular/router";

@Injectable()

export class SupportService extends BaseService {

  constructor(private appComponent: AppComponent, protected http: HttpClient, router: Router) {
    super(http, router);
  }

  getFaqList(locale: string): Observable<SupportFaq[]> {
    let params = new HttpParams();

    if (locale != null) params = params.append('locale', locale);

    return this.httpGet<SupportFaq[]>("/Support/Faq?" + params.toString());
  }

  getFaq(supportFaq_ID: number): Observable<SupportFaq> {
    return this.httpGet<SupportFaq>("/Support/Faq/" + supportFaq_ID);
  }

  editFaq(supportFaq_ID: number): Observable<SupportFaq> {
    return this.httpGet<SupportFaq>("/Support/Faq/" + supportFaq_ID);
  }

  saveFaq(faq: SupportFaq): Observable<SupportFaq> {
    if (faq.supportFaq_ID == null)
      return this.httpPost<SupportFaq>("/Support/Faq", faq);
    else
      return this.httpPut<SupportFaq>("/Support/Faq/" + faq.supportFaq_ID, faq);
  }

  deleteFaq(supportFaq_ID: number): Observable<number> {
    return this.httpDelete<number>("/Support/Faq/" + supportFaq_ID);
  }

  resequenceSupportFaqs(faqs: SupportFaq[]): Observable<SupportFaq[]> {
    return this.httpPut<SupportFaq[]>("/Support/Faqs/resequence", faqs);
  }

}
